module.exports = __webpack_public_path__ + "static/media/power2x-m.b2c39861.jpg";